import React, { memo } from 'react'
import styles from './EmptyApplianceFormView.module.scss'

type Props = {
    onButtonClick: () => void
}

const EmptyApplianceFormView: React.FC<Props> = memo((props: Props) => {
    const { onButtonClick } = props

    return (
        <div className={styles.container}>
            <div className={styles.imageContainer}>
                <svg viewBox="0 0 20 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.5199 29.1663V24.4996L0.833984 18.5317V10.3309C0.833984 9.61372 1.08947 8.99925 1.60044 8.48747C2.11139 7.97569 2.72485 7.7198 3.44082 7.7198H5.95365L4.90669 8.76676V0.833008H7.00065V7.7198H13.0006V0.833008H15.0945V8.76676L14.0476 7.7198H16.5604C17.2764 7.7198 17.8898 7.97569 18.4008 8.48747C18.9117 8.99925 19.1672 9.61372 19.1672 10.3309V18.5317L13.4813 24.4996V29.1663H6.5199Z" fill="url(#paint0_linear_1076_6424)" />
                    <defs>
                        <linearGradient id="paint0_linear_1076_6424" x1="7.5" y1="15" x2="14" y2="23" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#F68B1E" />
                            <stop offset="1" stopColor="#FF5C00" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            <div className={styles.title}>
                Appliance
            </div>
            <div className={styles.subtitle}>
                Find and add your home appliances to calculate your energy usage
            </div>
            <button className={`standardButton ${styles.button}`} onClick={onButtonClick}>
                Add appliance <span className={styles.plus}>+</span>
            </button>

        </div>
    )
})

export default EmptyApplianceFormView